/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained

access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import { useCallback, useState } from 'react';
import useAbortController from './useAbortController';
import axiosCall from '../../services/axios';
import { getErrorFromEndpoint, isObjEmptyOrNull, isStrEmptyOrNull } from '../UtilityFunctions';

enum Status {
  LOADING = 'Loading',
  READY = '',
}

type ipResponse = {
  ip: string;
};

const useIPData = () => {
  const { get } = useAbortController();
  const [IPResp, setIPResp] = useState(null);
  const [IPErrors, setIPErrors] = useState('');
  const [IPStatus, setIPStatus] = useState(Status.READY);

  const IPAPI = useCallback(async (): Promise<ipResponse> => {
    const urlPath = process.env.REACT_APP_IP;
    const request = { url: urlPath, method: 'get' };
    const config = get();

    const res = await axiosCall(request, config, {}, false)
      .then((res) => {
        if (!isObjEmptyOrNull(res)) {
          const err = getErrorFromEndpoint(res);
          if (isStrEmptyOrNull(err)) {
            setIPResp(res);
            return res;
          } else {
            console.log(err);
            setIPResp(null);
            setIPErrors(err);
            return null;
          }
        }
        return null;
      })
      .catch((e: Error) => {
        console.log('Error using IPAPI in the useIPData hook: ', e);
        setIPErrors(e.message);
        setIPResp(null);
        return null;
      });
    setIPStatus(Status.READY);
    return res;
  }, [get]);

  const processIP = useCallback(async () => {
    setIPResp(null);
    setIPStatus(Status.LOADING);
    setIPErrors('');
    const res = await IPAPI();
    return res;
  }, [IPAPI]);

  return { IPResp, IPStatus, IPErrors, processIP };
};

export default useIPData;
